import React from 'react';

export default function Rooms() {
  // -------------------------------------------------------------------------
  // Data definitions
  // -------------------------------------------------------------------------
  const roomCategories = [
    {
      name: 'OASIS',
      subtitle: 'WIDOK NA OGRÓD',
      tagline: 'NASZE OGRODY U TWOICH STÓP',
      description:
        'Przytulne i bardzo jasne pokoje, w których poczujesz się jak w domu, gdzie możesz podziwiać piękno naszych ogrodów podczas odpoczynku z balkonu lub tarasu naszych pokoi Oasis.',
      extraInfo: 'Maksymalna pojemność pokoi Oasis to 3 osoby*',
      note: '*Łóżko małżeńskie lub dwa pojedyncze łóżka + rozkładana sofa. W tej kategorii dostępne są pokoje przystosowane dla osób niepełnosprawnych.',
      disclaimer:
        'Charakterystyka pokoi, taka jak lokalizacja lub wyposażenie, może się nieznacznie różnić',
      image: 'https://i.imgur.com/nNQXuN9.jpg',
      amenities: [
        { icon: 'ri-temp-cold-line', label: 'Klimatyzacja' },
        { icon: 'ri-goblet-line', label: 'Minibar (na życzenie)' },
        { icon: 'ri-safe-line', label: 'Sejf' },
        { icon: 'ri-music-line', label: 'Kanały muzyczne' },
        { icon: 'ri-phone-line', label: 'Telefon w pokojach' },
        { icon: 'ri-tv-line', label: 'Telewizja satelitarna' },
        { icon: 'ri-flashlight-line', label: 'Napięcie 220V' },
        { icon: 'ri-scissors-cut-line', label: 'Suszarka do włosów' },
        { icon: 'ri-layout-line', label: '30 m² w przybliżeniu (wliczając taras/balkon)' },
        { icon: 'ri-drop-line', label: 'Woda powitalna' }
      ]
    },
    {
      name: 'ARMONÍA',
      subtitle: 'Widok na morze z boku i ogród',
      tagline: 'ODPOCZYNEK W SERCU NATURY',
      description:
        'Boczne widoki na intensywny błękit oceanu i charakterystyczną zieleń ogrodów charakteryzują pokoje Armonía, tworząc idealną kombinację. Odkryj sam, jak te dwa kolory łączą się z balkonu lub tarasu Twojego pokoju Armonía i poczuj magię wyjątkowego i naturalnego otoczenia.',
      extraInfo: 'Maksymalna pojemność pokoi Armonía to 3 osoby*',
      note: '*Łóżko małżeńskie lub dwa pojedyncze łóżka + rozkładana sofa. W tej kategorii dostępne są pokoje przystosowane dla osób niepełnosprawnych.',
      disclaimer:
        'Charakterystyka pokoi, taka jak lokalizacja lub wyposażenie, może się nieznacznie różnić',
      image: 'https://i.imgur.com/55P2iRd.jpg',
      amenities: [
        { icon: 'ri-temp-cold-line', label: 'Klimatyzacja' },
        { icon: 'ri-goblet-line', label: 'Minibar (na życzenie)' },
        { icon: 'ri-safe-line', label: 'Sejf' },
        { icon: 'ri-music-line', label: 'Kanały muzyczne' },
        { icon: 'ri-phone-line', label: 'Telefon w pokojach' },
        { icon: 'ri-tv-line', label: 'Telewizja satelitarna' },
        { icon: 'ri-flashlight-line', label: 'Napięcie 220V' },
        { icon: 'ri-scissors-cut-line', label: 'Suszarka do włosów' },
        { icon: 'ri-layout-line', label: '30 m² w przybliżeniu (wliczając taras/balkon)' },
        { icon: 'ri-drop-line', label: 'Woda powitalna' }
      ]
    },
    {
      name: 'HORIZONTE',
      subtitle: 'Widok bezpośredni na morze',
      tagline: 'ROMANS MIĘDZY TOBĄ A MORZEM',
      description:
        'Podziwiaj imponujące piękno zachodów słońca żegnających dzień z nieskończonością morza z balkonu lub tarasu Twojego pokoju Horizonte, słuchając delikatnego szumu morza i śpiewu ptaków, lub czując, jak pierwsze promienie słońca ogrzewają Twoją skórę. Przebywanie na szczycie klifu i otoczenie oceanem pozwala przeżyć niezapomniane doświadczenia, takie jak obserwowanie delfinów, gdy zbliżają się do wybrzeży La Gomery.',
      extraInfo: 'Maksymalna pojemność pokoi Horizonte to 3 osoby*',
      note: '*Łóżko małżeńskie lub dwa pojedyncze łóżka + rozkładana sofa',
      disclaimer:
        'Charakterystyka pokoi, taka jak lokalizacja lub wyposażenie, może się nieznacznie różnić',
      image: 'https://i.imgur.com/BhO2HZ4.jpg',
      amenities: [
        { icon: 'ri-temp-cold-line', label: 'Klimatyzacja' },
        { icon: 'ri-goblet-line', label: 'Minibar (na życzenie)' },
        { icon: 'ri-safe-line', label: 'Sejf' },
        { icon: 'ri-music-line', label: 'Kanały muzyczne' },
        { icon: 'ri-phone-line', label: 'Telefon w pokojach' },
        { icon: 'ri-tv-line', label: 'Telewizja satelitarna' },
        { icon: 'ri-flashlight-line', label: 'Napięcie 220V' },
        { icon: 'ri-scissors-cut-line', label: 'Suszarka do włosów' },
        { icon: 'ri-layout-line', label: '30 m² w przybliżeniu (wliczając taras/balkon)' },
        { icon: 'ri-hotel-bed-line', label: 'Karta poduszek' },
        { icon: 'ri-brush-line', label: 'Kosmetyki Eco-Boutique' },
        { icon: 'ri-drop-line', label: 'Woda powitalna' },
        { icon: 'ri-shirt-line', label: 'Szlafrok i kapcie' }
      ]
    },
    {
      name: 'JUNIOR SUITE LAURISILVA',
      subtitle: 'WIDOK NA OGRÓD LUB MORZE',
      tagline: 'WIĘCEJ NIŻ ODPOCZYNEK: CZYSTY RELAKS!',
      description:
        'Każdy z naszych Junior Suite Laurisilva charakteryzuje się przestronnością i posiada salon oddzielony od sypialni drzwiami, które możesz otwierać lub zamykać według własnego uznania, tworząc intymną i wyjątkową atmosferę.',
      extraInfo:
        'Z balkonu lub tarasu Twojego pokoju Junior Suite Laurisilva możesz cieszyć się ekskluzywnym widokiem na ocean lub bujne ogrody hotelu.',
      note: 'Maksymalna pojemność pokoi Junior Suite Laurisilva to 3 osoby*',
      disclaimer:
        '*Łóżko małżeńskie lub dwa pojedyncze łóżka + rozkładana sofa. Charakterystyka pokoi, taka jak lokalizacja lub wyposażenie, może się nieznacznie różnić.',
      image: 'https://i.imgur.com/wA1s5AL.jpg',
      amenities: [
        { icon: 'ri-temp-cold-line', label: 'Klimatyzacja' },
        { icon: 'ri-goblet-line', label: 'Minibar (na życzenie)' },
        { icon: 'ri-safe-line', label: 'Sejf' },
        { icon: 'ri-music-line', label: 'Kanały muzyczne' },
        { icon: 'ri-phone-line', label: 'Telefon w pokojach' },
        { icon: 'ri-cup-line', label: 'Zestaw do kawy i herbaty' },
        { icon: 'ri-tv-line', label: 'Telewizja satelitarna' },
        { icon: 'ri-flashlight-line', label: 'Napięcie 220V' },
        { icon: 'ri-scissors-cut-line', label: 'Suszarka do włosów' },
        { icon: 'ri-layout-line', label: '56 m² w przybliżeniu (wliczając taras/balkon)' },
        { icon: 'ri-hotel-bed-line', label: 'Karta poduszek' },
        { icon: 'ri-brush-line', label: 'Kosmetyki Eco-Boutique' },
        { icon: 'ri-drop-line', label: 'Woda powitalna' },
        { icon: 'ri-shirt-line', label: 'Szlafrok i kapcie' },
        { icon: 'ri-sun-line', label: 'Łóżka balińskie Club Laurel (w zależności od dostępności)' }
      ]
    },
    {
      name: 'POKOJE RODZINNE ¨FAMILIARES¨',
      subtitle: 'RAZEM... ALE NIEZALEŻNIE',
      tagline: 'RAZEM... ALE NIEZALEŻNIE',
      description:
        'Podróżuj z rodziną bez rezygnacji z prywatności. W Hotel Jardín Tecina mamy dwie opcje, aby wszyscy czuli się jak w domu:',
      extraInfo:
        'Pokój Rodzinny: Przytulny i funkcjonalny, z maksymalną pojemnością dla 2 dorosłych i 2 dzieci. W pełni wyposażona jednostka dla rodziny, z rozkładaną sofą dla dzieci.',
      note:
        'Pokój Rodzinny MAXI: Idealny dla dużych rodzin, z maksymalną pojemnością 6 osób (2 dorosłych i 2 dzieci, 2 dorosłych i 4 dzieci lub 3 dorosłych i 3 dzieci). Jedna jednostka, dwa pokoje połączone wewnętrznie lub przez zewnętrzny ganek (w zależności od dostępności).',
      disclaimer:
        'Poproś o najlepszą opcję dla siebie i stwórz wyjątkowe wspomnienie dla swoich bliskich, gdzie komfort i zabawa idą w parze. Pokoje z widokiem na ogród. Widok na morze - zapytaj o dopłatę. Charakterystyka pokoi, taka jak lokalizacja lub wyposażenie, może się nieznacznie różnić.',
      image: 'https://i.imgur.com/vmYZdGK.jpg',
      amenities: [
        { icon: 'ri-temp-cold-line', label: 'Klimatyzacja' },
        { icon: 'ri-goblet-line', label: 'Minibar (na życzenie)' },
        { icon: 'ri-safe-line', label: 'Sejf' },
        { icon: 'ri-music-line', label: 'Kanały muzyczne' },
        { icon: 'ri-phone-line', label: 'Telefon w pokojach' },
        { icon: 'ri-tv-line', label: 'Telewizja satelitarna' },
        { icon: 'ri-flashlight-line', label: 'Napięcie 220V' },
        { icon: 'ri-scissors-cut-line', label: 'Suszarka do włosów' },
        { icon: 'ri-layout-line', label: '30 m² w przybliżeniu (wliczając taras/balkon)' },
        { icon: 'ri-drop-line', label: 'Woda powitalna' }
      ],
      isFamily: true
    }
  ];

  const commonAmenities = [
    'Klimatyzacja',
    'Bezpłatne Wi-Fi',
    'TV z płaskim ekranem',
    'Telefon',
    'Sejf',
    'Minibar',
    'Suszarka do włosów',
    'Balkon lub taras'
  ];

  // -------------------------------------------------------------------------
  // Render
  // -------------------------------------------------------------------------
  return (
    <section id="pokoje" className="py-24 px-6 bg-white">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-light text-stone-800 mb-4 tracking-wide">
            POKOJE I SUITES
          </h2>
          <div className="flex items-center justify-center gap-4 mb-6">
            <div className="w-16 h-px bg-stone-300"></div>
            <div className="w-2 h-2 bg-stone-400 rounded-full"></div>
            <div className="w-16 h-px bg-stone-300"></div>
          </div>
          <p className="text-stone-600 max-w-3xl mx-auto leading-relaxed">
            Znajdź typ pokoju, który najlepiej odpowiada Twoim potrzebom
          </p>
        </div>

        {/* Intro text */}
        <div className="max-w-4xl mx-auto text-center mb-16">
          <p className="text-stone-600 leading-relaxed mb-6">
            Nasze pokoje i Suites zostały zaprojektowane, aby zapewnić Ci maksymalny komfort podczas pobytu. Wszystkie kategorie oferują wspólne udogodnienia, które gwarantują przyjemny wypoczynek.
          </p>

          {/* Common amenities */}
          <div className="bg-stone-50 rounded-2xl p-8 mt-8">
            <h3 className="text-lg font-medium text-stone-700 mb-6">Wszystkie pokoje oferują:</h3>
            <div className="flex flex-wrap justify-center gap-3">
              {commonAmenities.map((amenity, idx) => (
                <span
                  key={idx}
                  className="bg-white px-4 py-2 rounded-full text-sm text-stone-600 shadow-sm"
                >
                  {amenity}
                </span>
              ))}
            </div>
          </div>
        </div>

        {/* Room cards */}
        <div className="space-y-16">
          {roomCategories.map((room, index) => (
            <div key={index} className={`${index % 2 === 0 ? '' : 'md:flex-row-reverse'}`}>
              <div
                className={`grid md:grid-cols-2 gap-8 items-center ${
                  index % 2 !== 0 ? 'md:grid-flow-dense' : ''
                }`}
              >
                {/* Image */}
                <div className={`relative ${index % 2 !== 0 ? 'md:col-start-2' : ''}`}>
                  <div className="relative overflow-hidden rounded-lg shadow-lg">
                    <img
                      src={room.image}
                      alt={room.name}
                      className="w-full h-[400px] object-cover object-top hover:scale-105 transition-transform duration-700"
                    />
                    {room.isFamily && (
                      <div className="absolute top-4 left-4 bg-teal-600 text-white px-4 py-2 rounded text-xs font-medium tracking-wider">
                        RODZINNY
                      </div>
                    )}
                  </div>
                </div>

                {/* Content */}
                <div className={`${index % 2 !== 0 ? 'md:col-start-1 md:row-start-1' : ''}`}>
                  <div className="space-y-4">
                    <div>
                      <h3 className="text-3xl font-light text-stone-800 tracking-wide mb-1">
                        {room.name}
                      </h3>
                      <p className="text-sm text-amber-700 font-medium tracking-wider uppercase">
                        {room.subtitle}
                      </p>
                    </div>

                    <p className="text-stone-600 leading-relaxed">{room.description}</p>

                    <p className="text-sm text-stone-500 italic">{room.extraInfo}</p>

                    <p className="text-xs text-stone-400">{room.note}</p>

                    {room.disclaimer && (
                      <p className="text-xs text-stone-400 italic">{room.disclaimer}</p>
                    )}

                    {/* Amenities */}
                    {room.amenities && (
                      <div className="grid grid-cols-2 gap-3">
                        {room.amenities.map((amenity, idx) => (
                          <div key={idx} className="flex items-center gap-2">
                            <div className="w-5 h-5 flex items-center justify-center flex-shrink-0">
                              <i className={`${amenity.icon} text-stone-400`}></i>
                            </div>
                            <span className="text-xs leading-tight">{amenity.label}</span>
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Bottom section - Vive cada minuto */}
        {/* Removed section */}
      </div>
    </section>
  );
}
